import { GetterTree } from 'vuex';

import { ClientStatus, StateType } from './state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const moduleGetters: GetterTree<StateType, any> = {
  isConnected(state) {
    return state.status === ClientStatus.CONNECTED;
  },

  selectedXmppUrl() {
    return process.env.VUE_APP_XMPP_SERVER_URL;
  },

  currentDomain(state, getters) {
    const url: string = getters.selectedXmppUrl;
    const { hostname } = new URL(url);
    return hostname;
  },

  currentJID(state, getters, rootState, rootGetters) {
    const jidNode = rootGetters['apiSession/jidNode'];
    const domain = getters.currentDomain;
    if (!jidNode || !domain) return null;
    return `${jidNode}@${domain}`;
  },
};

export default moduleGetters;
